/** User-facing copy for workspace Agent resources. STE. */

export const AGENT_RESOURCES_COPY = {
  title: "Agent resources",
  helper:
    "Agents on every run in this workspace can use these resources. One signed-in account is shared by every agent.",
  refinementNote:
    "These MCP servers can change systems outside SuperPlane during refinement. The repository stays read-only.",
  connectionsTab: "MCP servers",
  skillsTab: "Skills",
  addConnection: "Add MCP server",
  editConnection: "Edit MCP server",
  dialogDescription: "Agents on every run in this workspace can use this MCP server.",
  addSkill: "Add skill",
  editSkill: "Edit skill",
  skillDialogDescription: "Agents on every run in this workspace can use this SKILL.md file.",
  skillExtraFilesNote: "Skills that need extra files are not supported.",
  emptyConnectionsTitle: "No MCP servers yet.",
  emptyConnectionsBody: "Add an MCP server so agents can use it on every run.",
  unnamedResource: "MCP server",
  unnamedSkill: "skill",
  deleteDescription: "This removes the MCP server for every agent in this workspace.",
  deleteSkillDescription: "This removes the skill for every agent in this workspace.",
  emptySkillsTitle: "No skills yet.",
  emptySkillsBody: "Add a SKILL.md so agents can use it on every run.",
  skillSourceInline: "SKILL.md",
  authHeader: "Header",
  authSignIn: "Sign-in",
  statusConnected: "Connected",
  statusNotConnected: "Not connected",
  statusReconnect: "Reconnect",
  statusReady: "Ready",
  statusFetchFailed: "Failed to fetch",
  connect: "Connect",
  reconnect: "Reconnect",
  disconnect: "Disconnect",
  edit: "Edit",
  delete: "Delete",
  saveConnection: "Save MCP server",
  saveSkill: "Save skill",
  cancel: "Cancel",
  nameLabel: "Name",
  nameHelper: "Use lowercase letters, numbers, and dashes. The name superplane is reserved.",
  urlLabel: "URL",
  urlHelper: "Use an https URL. Private hosts are not allowed.",
  markdownLabel: "SKILL.md",
  markdownHelper: "Paste the skill markdown. Extra files are not included.",
  authLabel: "Authentication",
  headersLabel: "Headers",
  headerNameLabel: "Header name",
  headerSecretLabel: "Secret",
  addHeader: "Add header",
  removeHeader: "Remove header",
  loading: "Loading agent resources...",
  loadError: "SuperPlane could not load agent resources. Try again.",
  nameRequired: "Name is required.",
  nameInvalid: "Use a lowercase name that starts with a letter. Use letters, numbers, and dashes.",
  nameReserved: "The name superplane is reserved.",
  urlRequired: "URL is required.",
  urlInvalid: "Enter an https URL.",
  markdownRequired: "SKILL.md content is required.",
  headersHelper: "Add a header only when the server needs a credential.",
  headerIncomplete: "Each header needs a name and a secret.",
  created: "MCP server added.",
  updated: "MCP server updated.",
  deleted: "MCP server deleted.",
  skillCreated: "Skill added.",
  skillUpdated: "Skill updated.",
  skillDeleted: "Skill deleted.",
  disconnected: "MCP server disconnected.",
  createFailed: "SuperPlane could not add the MCP server.",
  updateFailed: "SuperPlane could not update the MCP server.",
  deleteFailed: "SuperPlane could not delete the MCP server.",
  skillCreateFailed: "SuperPlane could not add the skill.",
  skillUpdateFailed: "SuperPlane could not update the skill.",
  skillDeleteFailed: "SuperPlane could not delete the skill.",
  connectFailed: "SuperPlane could not start sign-in.",
  disconnectFailed: "SuperPlane could not disconnect the MCP server.",
  noUpdatePermission: "You do not have permission to update agent resources.",
} as const;
